module.exports = __webpack_public_path__ + "static/img/dsdk.dc60572c.png";